import { GzNetworkFeedbackFormWebComponent } from './component/GzNetworkFeedbackFormWebComponent';

export { GzNetworkFeedbackFormWebComponent };
